import * as React from 'react';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// TODO: Hard Coded Styling, Need to change to dyniamic width according to length of word but with a minWidth and maxWidth
const CustomPaper = styled(Paper)(({theme}) => ({
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'start',
    justifyContent: 'center',
    padding: '20px',
    gap: '10px',
    '&:hover': {
        background: '#555456',
    },
}))

export default function RoadmapCards({data, cardPosition, type, index, identifier}) {

    const slugify = (str) => {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    }

    const navigate = useNavigate()

    const handleQuestionClicked = (idQuestion) => {
        navigate(`/ideNew/${idQuestion}`)
    }

    return (
        <CustomPaper square={false} onClick={() => handleQuestionClicked(data.idQuestion.toString())} data-cy={`${type}-card-${slugify(data.Problem)}`}
        sx={{
            maxWidth: type === "minimap" ? "250px" : "450px",
            height: type === "minimap" ? "80px" : "120px",
            borderRadius: type === "minimap" ? "15px" : '25px',
            marginRight: type === "list" ? '370px' : 0,
            marginBottom: (cardPosition === 0 && type === "map") ? 30 : (cardPosition === 1 && type === "minimap") ? 20 : 0,
            marginTop: (cardPosition === 1 && type === "map") ? 30 : (cardPosition === 0 && type === "minimap") ? 18 : 0,
            background: "#414042",
            border: index === 0 ? '4px solid rgb(0, 255, 200)' : '2.5px solid #302E35',
        }}>
            <Typography variant='h6' sx={{
                color: '#F4EEEE',
                fontSize: type === "minimap" ? 10 : 16
            }}>
                {data.Problem}
            </Typography>
            <Typography sx={{
                color: data.Difficulty === 'Easy' ? '#379437' : data.Difficulty === 'Medium' ? '#C69115' : '#CC3939',
                fontWeight: 'bold',
                fontSize: type === "minimap" ? 10 : 16
            }}>
                {`Difficulty: ${data.Difficulty}`}
            </Typography>
        </CustomPaper>
    )
}